import React from 'react'
import PropTypes from 'prop-types'

import { Text, TEXT_VARIANT_LIGHT, Flex } from 'mailup-web-components'

import { storeGet, STORE_KEY_LISTS_COUNT } from 'mailup-react-helpers'

const ListCell = ({ idList }) => {
  const listsCount = storeGet(STORE_KEY_LISTS_COUNT)

  if (listsCount <= 1) return null

  return (
    <Flex padding='24px 16px'>
      <Text variant={TEXT_VARIANT_LIGHT}>{idList}</Text>
    </Flex>
  )
}

export default ListCell

ListCell.propTypes = {
  idList: PropTypes.number
}
